import { Label } from '../label';
import { FieldInfo } from './FieldInfo';
import { type AnyFieldApi } from '@tanstack/react-form';
import { cn } from '../../cn';
import { InfoIcon } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogFooter,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@drisk-ai/ui';

type FieldItemProps = {
  label?: string;
  children: React.ReactNode;
  field?: AnyFieldApi;
  isRequiredSymbol?: boolean;
  className?: string;
  renderInfo?: () => React.ReactNode;
  infoButtonTitle?: string;
};

export const FieldItem = ({
  label,
  field,
  children,
  isRequiredSymbol,
  className,
  renderInfo,
  infoButtonTitle = 'Understand',
}: FieldItemProps) => {
  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      data-field-name={field?.name}
      data-field-error={field ? field.state.meta.errors.length > 0 : null}
    >
      {label ? (
        <Label className="text-sm flex">
          {label}
          {isRequiredSymbol ? <span>*</span> : null}

          {renderInfo ? (
            <Dialog>
              <DialogTrigger asChild>
                <InfoIcon className="w-4 h-4 ml-2 text-muted-foreground cursor-pointer" />
              </DialogTrigger>
              <DialogContent className="max-w-[600px]">
                {renderInfo()}
                <DialogFooter>
                  <DialogClose asChild>
                    <Button>{infoButtonTitle}</Button>
                  </DialogClose>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          ) : null}
        </Label>
      ) : null}

      {children}
      {field ? <FieldInfo field={field} /> : null}
    </div>
  );
};
